<template>
	<v-dialog
		v-model="localShowDialog"
		:width="$vuetify.display.mobile ? '95%' : '500px'"
		:persistent="buttonIsLoading"
		@click:outside="handleDismiss"
		@keydown.esc="handleDismiss"
	>
		<v-card class="sgnl-pb-0">
			<v-card-title class="dialog-header sgnl-subtitle-medium"
				>Sign Out From All Devices
				<v-spacer />
				<v-btn
					icon
					variant="text"
					size="small"
					@click="handleDismiss"
				>
					<Close16 />
				</v-btn>
			</v-card-title>
			<v-divider />
			<div class="dialog-body sgnl-paragraph-s-regular sgnl-text-color-secondary">
				<div>Please note:</div>
				<ul class="ul-list">
					<li><DotMark16 class="ul-icon" />This will sign you out from all browsers and devices.</li>
					<li>
						<DotMark16 class="ul-icon" />You will need to sign in again on this device to continue using the
						platform.
					</li>
					<li>
						<DotMark16 class="ul-icon" />Active sessions may remain valid for up to 1 hour until tokens
						expire.
					</li>
				</ul>
				<v-alert
					v-if="showSupportMessage"
					density="compact"
					variant="outlined"
					type="warning"
					border="start"
				>
					{{ getSupportMessage }}
				</v-alert>
			</div>
			<v-divider />
			<v-card-actions class="dialog-footer">
				<v-btn
					variant="outlined"
					@click="handleDismiss"
				>
					Cancel
				</v-btn>
				<v-btn
					variant="flat"
					color="primary"
					:loading="buttonIsLoading"
					@click="logoutFromAllDevicesAction"
				>
					Sign Out From All
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import Close16 from "@carbon/icons-vue/es/close/16";
import DotMark16 from "@carbon/icons-vue/es/dot-mark/16";
import { useUserStore } from "@/stores/user";
import { sdk } from "@/js/sdk";
import { signOut } from "aws-amplify/auth";
import { useOutputsStore } from "@/stores/outputs";

const SupportMessage = `Please try again later.\n If this issue persists, please contact Signaloid Support at\n developer-support@signaloid.com. `;

export default defineComponent({
	name: "LogoutFromAllDevicesDialog",
	components: { Close16, DotMark16 },
	emits: ["update:showDialog", "logout-from-all", "closeLogoutFromAllDialog"],
	data: () => ({
		buttonIsLoading: false,
		showSupportMessage: false,
	}),
	props: {
		showDialog: { type: Boolean, default: false },
		passedEmail: {
			type: String,
			default: null,
		},
	},
	computed: {
		localShowDialog: {
			get() {
				return this.showDialog;
			},
			set(value) {
				this.$emit("update:showDialog", value);
			},
		},
		getSupportMessage() {
			return SupportMessage;
		},
	},
	setup() {
		const userStore = useUserStore();
		const taskOutputsStore = useOutputsStore();
		return { userStore, taskOutputsStore };
	},
	methods: {
		async logoutFromAllDevicesAction() {
			this.buttonIsLoading = true;
			try {
				const resp = await sdk.users.logoutAllSessions(this.userStore.currentUser.userID);

				console.log(resp.status);
				this.buttonIsLoading = false;
				this.$emit("logout-from-all", "success");
				this.$posthog?.capture("logout_from_all_devices");
				await this.taskOutputsStore.purgeCache();
				await signOut();
				window.location.href = "/";
			} catch {
				this.buttonIsLoading = false;
				this.showSupportMessage = true;
				this.$emit("logout-from-all", "failure");
			}
		},
		handleDismiss() {
			if (this.buttonIsLoading) {
				return;
			}
			this.closeDialog();
		},
		closeDialog() {
			this.$emit("closeLogoutFromAllDialog");
		},
	},
});
</script>
